var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-content"},[_c('h1',{staticClass:"md-mt-2"},[_vm._v(_vm._s(_vm.$t("general.legal")))]),_c('div',{staticClass:"md-layout-item md-layout md-size-100 t-l md-p-4"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.textWithBR(_vm.$t('general.legalText')))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }